export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Generate login URL at runtime
export const getLoginUrl = () => {
  // For self-hosted deployments with Authentik or other OAuth providers,
  // redirect to the backend OAuth endpoint which handles the flow
  const viteLoginUrl = import.meta.env.VITE_LOGIN_URL;

  if (viteLoginUrl) {
    // Use explicitly configured login URL
    return viteLoginUrl;
  }

  // Default to backend login endpoint
  return "/api/oauth/login";
};
